import request from '@/utils/request'

// 修改关注状态
export function changeStatus(data) {
  return request({
    url: '/crmFocus/changeStatus',
    method: 'post',
    data: data
  })
}
